import './news-and-media-card.scss';

const className = 'news-and-media-card';
const NewsAndEventsCard = (props) => {
	const {
		title,
		image_URL,
		post_date,
		permalink,
		excerpt,
		categories,
		event_date,
	} = props;
	let image_class = `${className}__image`;
	if (image_URL && image_URL.includes('fallback')) {
		image_class = `${className}__image--fallback`;
	}

	return (
		<div className={className}>
			<div className={`${className}__image-wrap`}>
				<span dangerouslySetInnerHTML={{ __html: categories }}></span>
				<a href={permalink}>
					<img className={image_class} alt={title} src={image_URL} />
				</a>
			</div>
			<article className={`${className}__article`}>
				<p className={`${className}__post-date`}>
					Published: {post_date}
				</p>
				{event_date && (
					<h6 className={`${className}__event-date`}>
						<svg
							className="<?php echo esc_attr($base) ?>__event-icon"
							xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="20"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						>
							<rect
								width="18"
								height="18"
								x="3"
								y="4"
								rx="2"
								ry="2"
							/>
							<line x1="16" x2="16" y1="2" y2="6" />
							<line x1="8" x2="8" y1="2" y2="6" />
							<line x1="3" x2="21" y1="10" y2="10" />
						</svg>
						{event_date}
					</h6>
				)}
				<span dangerouslySetInnerHTML={{ __html: categories }}></span>
				<h6 className={`${className}__headline`}>{title}</h6>
				<p className={`${className}__excerpt`}>{excerpt}</p>
				<a href={permalink} className={`${className}__link`}>
					Read more
					<svg
						className={`${className}__link-arrow`}
						viewBox="0 -960 960 960"
					>
						<path d="M480-345 240-585l43-43 197 198 197-197 43 43-240 239Z" />
					</svg>
				</a>
			</article>
		</div>
	);
};
export default NewsAndEventsCard;
